import { background, divider } from "@/theme/colors";
import { elevation, rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, StackProps } from "@mui/material";

type TFooterContainerProps = {
  justifyContent?: StackProps["justifyContent"];
};

export const FooterContainer: FCC<TFooterContainerProps> = ({ children, justifyContent = "space-between" }) => {
  return (
    <Stack
      direction="row"
      justifyContent={justifyContent}
      alignItems="center"
      sx={{
        position: "sticky",
        bottom: "32px",
        zIndex: 1000,
        background: background.white,
        borderTop: `1px solid ${divider.middle}`,
        borderRadius: rounded.sm,
        boxShadow: elevation.lv2,
        padding: "24px",
      }}
    >
      {children}
    </Stack>
  );
};
